import { Button, Icon, Modal, DatePicker, Divider, Input, Checkbox, Select } from "antd";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import React, { useEffect, useState } from "react";
import GeneratedReport from "./GeneratedReports";

import { fetchAllStoresApi, fetchCohortAdminListApi, ExportRequestedReportApi } from "utils/apiService";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ExportReportModal = (props) => {
    const [reportData, setReportData] = useState({
        start_date: "",
        end_date: "",
        report_type: "",
        report_contraints: {},
    });

    const [cohortList, setCohortList] = useState([]);
    const [reportConstraints, setReportConstraints] = useState({
        cohort_list: [],
        store_list: [],
    });

    const [storeList, setStoreList] = useState([]);

    useEffect(() => {
        if (props.createReport) {
            fetchAllStoresApi({
                requestData: {},
                resCallback: () => { },
                res200Callback: (res) => {
                    setStoreList(res.data.store_list);
                },
            });
            fetchCohortAdminListApi({
                requestData: {},
                resCallback: () => { },
                res200Callback: (res) => {
                    setCohortList(res.data.cohort_list);
                },
            });
        }
    }, [props.createReport]);

    return (
        <Modal
            visible={props.createReport}
            footer={
                <div style={{ margin: "8px 0px" }}>
                    <Button
                        style={{ border: "1px solid #d9d9d9", color: "#181818" }}
                        onClick={() => {
                            props.setCreateReport(false);
                            setReportConstraints({
                                cohort_list: [],
                                store_list: [],
                            });
                            setReportData({
                                start_date: "",
                                end_date: "",
                                report_type: "",
                                report_contraints: {},
                            });
                        }}>
                        Cancel
                    </Button>
                    <Button
                        style={{ backgroundColor: "#fec708", color: "#ffffff" }}
                        onClick={() => {
                            let jsondata;
                            if (props.modalflag === "transaction")
                                jsondata = {
                                    ...reportData,
                                    report_type: "TRANSACTIONS",
                                    report_contraints: reportConstraints,
                                };
                            else if (props.modalflag === "voucher")
                                jsondata = {
                                    ...reportData,
                                    report_type: "VOUCHERS",
                                    report_contraints: reportConstraints,
                                };
                            else
                                jsondata = {
                                    ...reportData,
                                    report_type: "CUSTOMER_DETAILS",
                                    report_contraints: reportConstraints,
                                };

                            ExportRequestedReportApi({
                                requestData: jsondata,
                                resCallback: () => { },
                                res200Callback: (res) => {
                                    props.setCreateReport(false);
                                    setReportConstraints({
                                        cohort_list: [],
                                        store_list: [],
                                    });
                                    setReportData({
                                        start_date: "",
                                        end_date: "",
                                        report_type: "",
                                        report_contraints: {},
                                    });
                                    props.loadtable();
                                },
                            });
                        }}>
                        Generate Report
                    </Button>
                </div>
            }
            title={
                <div
                    style={{
                        fontSize: "20px",
                    }}>
                    <Icon
                        type='file-text'
                        style={{
                            strokeWidth: "20", // --> higher value === more thickness the filled area
                            stroke: "black",
                            marginRight: "16px",
                        }}
                    />
                    {props.modalflag === "transaction"
                        ? "Generate Transaction Report"
                        : props.modalflag === "voucher"
                            ? "Generate Voucher Report"
                            : "Generate Customer Report"}
                </div>
            }
            destroyOnClose={true}
            maskClosable={false}
            width={"600px"}
            onCancel={() => {
                props.setCreateReport(false);
            }}>
            <div>
                <div>
                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#000000", margin: "8px 0px" }}>
                        Select Dates
                    </div>
                    <div>Select custom dates for generating report</div>
                    <RangePicker
                        style={{
                            border: "1px solid #D9D9D9",
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            backgroundColor: "#FFFFFF",
                            margin: "24px 0px 0px 0px",
                            width: "100%",
                        }}
                        value={[
                            reportData?.start_date ? moment(reportData?.start_date, "YYYY-MM-DD") : null,
                            reportData?.end_date ? moment(reportData?.end_date, "YYYY-MM-DD").subtract(1, "d") : null,
                        ]}
                        bordered={true}
                        onChange={(value) => {
                            setReportData({
                                start_date: value[0]?.format("YYYY-MM-DD") || "",
                                end_date: value[1]?.add(1, "d").format("YYYY-MM-DD") || "",
                            });
                        }}
                    />
                </div>
                <Divider />
                {props.modalflag === "voucher" || props.modalflag === "customer" ? (
                    <>
                        {" "}
                        <div>
                            <div style={{ fontSize: "16px", fontWeight: "700", color: "#000000", margin: "8px 0px" }}>
                                Select Customer Cohort
                            </div>
                            <div>Select customers or generate report for all.</div>
                            <div
                                style={{
                                    margin: "24px 0px",
                                    width: "100%",
                                    // display: "flex",
                                    // flexDirection: "column",
                                }}>
                                <Text style={{ color: "#000000", fontWeight: "500" }}>Cohort</Text>
                                <Select
                                    showSearch
                                    mode='multiple'
                                    style={{ margin: "4px 0px" }}
                                    className={"time-value-cohort-col-main-element"}
                                    placeholder={"Search by Name"}
                                    value={reportConstraints?.cohort_list}
                                    onChange={(e) =>
                                        setReportConstraints({
                                            ...reportConstraints,
                                            cohort_list: e,
                                        })
                                    }
                                    filterOption={(input, option) => (option.props.name.toLowerCase().includes(input.toLowerCase()))}
                                    optionLabelProp='name'>
                                    {cohortList?.map((cohortItem) => (
                                        <Option value={cohortItem.uuid} key={cohortItem.uuid} name={cohortItem.name}>
                                            {cohortItem.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                    </>
                ) : (
                    <div>
                        <div style={{ fontSize: "16px", fontWeight: "700", color: "#000000", margin: "8px 0px" }}>
                            Select Store
                        </div>
                        <div>Select a store to generate report</div>
                        <div style={{ marginTop: "24px", width: "100%" }}>
                            <Text style={{ color: "#000000", fontWeight: "500" }}>Search Store</Text>
                            <Select
                                showSearch
                                mode='multiple'
                                style={{ margin: "4px 0px" }}
                                className={"time-value-cohort-col-main-element"}
                                placeholder={"Search by store ID, store name"}
                                value={reportConstraints?.store_list}
                                onChange={(e) => {
                                    console.log(e);
                                    setReportConstraints({
                                        ...reportConstraints,
                                        store_list: e,
                                    });
                                }}
                                optionFilterProp="children"
                                filterOption={(input, option) => (option.props.name.toLowerCase().includes(input.toLowerCase()) ||
                                                                  option.props.sap_code.includes(input)) ||
                                                                  option.props.company_code.toLowerCase().includes(input.toLowerCase())
                                    }
                                optionLabelProp={"name"}>
                                {storeList?.map((storeItem) => (
                                    <Option value={storeItem.uuid} key={storeItem.uuid} name={storeItem.name} sap_code={storeItem.sap_code} company_code={storeItem.company_code} >
                                        {storeItem.name} - {storeItem.sap_code} - {storeItem.company_code}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ExportReportModal;
